export const VIEW_HEADER_MOBILE_HEIGHT = 64;
export const EDITOR_MOBILE_PREVIEW_NOTICE_HEIGHT = 48;
export const EDITOR_HEADER_HEIGHT = 56;
export const PREVIEW_HEADER_HEIGHT = 72;
